// Contenido del InfoWindow de Google Maps como nodo DOM.
//
// El título y las notas de un marcador los escribe el levantador. Antes se
// interpolaban dentro de un string HTML (`content: \`<strong>${m.title}…\``),
// así que un marcador con `<img onerror=…>` ejecutaba JavaScript en la sesión
// del cliente que abría el mapa (XSS almacenado). Con textContent se muestran
// tal cual, como texto.
export function buildInfoWindowContent({ title, label, notes }) {
  const root = document.createElement('div');
  root.style.cssText = 'font-family: sans-serif; padding: 4px;';

  const strong = document.createElement('strong');
  strong.textContent = title;

  const detail = document.createElement('span');
  detail.style.cssText = 'font-size:11px;color:#666';
  detail.textContent = notes ? `${label} — ${notes}` : label;

  root.append(strong, document.createElement('br'), detail);
  return root;
}
